module.exports = __webpack_public_path__ + "static/media/small-logo-claims.a3f9eb74.svg";